// Option lists and field builders shared by the wizard forms.

export const DEPOSITION_OPTIONS = [
  { value: '0', label: 'Unknown' },
  { value: '1', label: 'Extended Supine' },
  { value: '2', label: 'Flexed on the Left' },
  { value: '3', label: 'Flexed on the Right' },
  { value: '4', label: 'Irregular Burials' },
  { value: '5', label: 'Supine with Flexed Legs' },
  { value: '6', label: 'Supine with Open Legs' }
];

export const INTERNMENT_OPTIONS = [
  { value: '1', label: 'Cremation' },
  { value: '2', label: 'Inhumation' }
];

export const siteField = (sites = [], value) => ({
  key: 'siteId',
  label: 'Site',
  type: 'select',
  options: sites.map((site) => ({ value: String(site.id), label: site.name })),
  value
});
